import React, {Component} from 'react';
import $ from 'jquery'
import * as Common from '../CommonControlls/CommonJs';
import {connect} from 'react-redux'
import LandingLayout from '../CommonControlls/LandingLayout';
import ContactUs_bg from '../../images/ContactUs_bg.jpg'
import LandingPage_bg from '../../images/LandingPage_bg.jpg'
import AppLogo_Background from '../../images/AppLogo_Background.png'
import apkicon from '../../images/apkicon.jpg'
import riderModel from '../../images/riderModel.png'
// import appdebug from '../../AndroidAppRelease/appdebug.apk'


const mapStateToProps = (store) => {
    return store
}

const mapDispatchToProps = (dispatch) => {
    return {
        ShowAlert: (Settings) => {
            dispatch({type: "UpdateAlert", payload: Settings})
        },
        ShowLoader: (Isloading) => {
            dispatch({type: "UpdateLoader", payload: Isloading})
        },
    }
}

class Landing extends Component {
    render() {


        return (
            <div>

                <LandingLayout/>

                <div style={{background: "white"}}>

                    <div class="bg-container">
                        <img class="landingpage-topbackgroundImg" src={LandingPage_bg} style={{width: "100%"}}/>
                        <div class="bg-content">
                            <h1>Spotlight</h1>
                            <p style={{color: "white"}}>Get inspired, get involved.</p>
                        </div>
                    </div>

                    {/* <div class="sale-statistic-area" style={{marginTop:"70px"}}>
        <div class="landing-container" style={{paddingBottom:"50px",borderBottom:"1px solid #E1E0E1"}}>
            <div class="row" style={{marginRight:"0px",marginLeft:"0px"}}>

                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-">
                <h1 style={{textAlign:"center",fontWeight:"600",fontSize:"2rem",fontFamily:"'TiemposText-Semibold',serif",letterSpacing:"-0.5px"}}>What We Do</h1>                   
                </div>
                
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginTop:"20px"}}>
                <h4 style={{fontWeight:"400",fontSize:"1.125rem"}}>In more than 40 countries around the world, our nearly 6,000 team members work side by side with people living through poverty, disaster, violent conflict and the acute impacts of climate change. We’re committed to creating global change through local impact — 85 percent of our team members are from the countries where they work.</h4>                   
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <h4 style={{fontWeight:"400",fontSize:"1.125rem",marginTop:"20px"}}>We bring a comprehensive approach to every challenge, addressing problems from multiple angles. Thanks to support from our extended global community, we’ve provided $4 billion in lifesaving assistance to meet the urgent needs of more than 220 million people over nearly 40 years. We also go beyond emergency aid, partnering with local governments, forward-thinking corporations, social entrepreneurs and people living in fragile communities to develop bold solutions that make lasting change possible.</h4>                   
                </div>
              
            </div>
        </div>
</div> */}

                    <div class="sale-statistic-area" style={{background: "white", padding: "50px 0px"}}>
                        <div class="landing-container" style={{maxWidth: "1070px"}}>
                            <div class="row" style={{marginRight: "0px", marginLeft: "0px"}}>

                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <h1 style={{
                                        textAlign: "center",
                                        fontWeight: "600",
                                        fontSize: "2rem",
                                        fontFamily: "'TiemposText-Semibold',serif",
                                        letterSpacing: "-0.5px"
                                    }}> Our Background</h1>
                                </div>

                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <h4 style={{
                                        textAlign: "justify",
                                        fontWeight: "400",
                                        fontSize: "1.125rem",
                                        marginTop: "20px"
                                    }}>
                                        For TB control, timely and accurate diagnosis is one of the key system-level
                                        efforts that can potentially save lives and reduce the burden of disease by
                                        interrupting transmission of TB. GeneXpert is an advanced molecular diagnostic
                                        technique/machine that has significantly better sensitivity to detect TB in a
                                        sample than conventional microscopy testing. GeneXpert testing detects
                                        additional cases, which are otherwise missed because of lower sensitivity of
                                        microscopy. To this end, substantial amount of funds on the procurement and
                                        installation of diagnostic machines (GeneXpert) hsa bewith little focus on
                                        making people’s access easier and on improving the utilization of these
                                        machines.
                                    </h4>
                                    <h4 style={{
                                        textAlign: "justify",
                                        fontWeight: "400",
                                        fontSize: "1.125rem",
                                        marginTop: "20px"
                                    }}>
                                        Currently, there is no field arrangement to ensure that the presumptive TB cases
                                        from remote sites get access to accurate and rapid diagnosis. If an individual
                                        is able to reach a medical facility, it is less likely that they will revisit
                                        the facility to collect results and consult with a doctor. These repeated visits
                                        result in out-of-pocket expenses for presumptive cases, and therefore these
                                        services remain underutilized.
                                    </h4>
                                    <h4 style={{
                                        textAlign: "justify",
                                        fontWeight: "400",
                                        fontSize: "1.125rem",
                                        marginTop: "20px"
                                    }}>
                                        MC aims to increase patients’ access to timely and quality diagnosis by
                                        implementing the riders model for sputum transportation.
                                    </h4>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="sale-statistic-area" style={{background: "white", padding: "50px 0px"}}>
                        <div class="landing-container" style={{maxWidth: "1070px"}}>
                            <div class="row" style={{marginRight: "0px", marginLeft: "0px"}}>

                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <h1 style={{
                                        textAlign: "center",
                                        fontWeight: "600",
                                        fontSize: "2rem",
                                        fontFamily: "'TiemposText-Semibold',serif",
                                        letterSpacing: "-0.5px"
                                    }}>Riders Model</h1>
                                </div>

                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <h4 style={{
                                        textAlign: "justify",
                                        fontWeight: "400",
                                        fontSize: "1.125rem",
                                        marginTop: "20px"
                                    }}>
                                        The proposed model pivots on the development of technology which includes
                                        development of an Android-based mobile application, ride management system
                                        (RMS), rule-based messaging system (RBMS) and their integration with Mercy
                                        Corps’ owned Management Information System (PPM-MIS).
                                    </h4>
                                    <h4 style={{
                                        textAlign: "justify",
                                        fontWeight: "400",
                                        fontSize: "1.125rem",
                                        marginTop: "20px"
                                    }}>
                                        The selected districts will be divided into different zones, according to
                                        collection and drop off points, and each zone will be assigned to specific
                                        rider/s to collect and deliver the sputum samples of all pulmonary cases. The
                                        collection or pick-up pints will be PPM labs and selected Basic Health Units and
                                        Rural Health Centers, whereas the drop off points will be Xpert testing sites.
                                        At each pick up and drop off location, the rider will scan the barcode to
                                        confirm pick and drop off sputum sample. A message will be sent to the
                                        management information system for both pick up and drop off for each rider. Each
                                        rider will be registered online through a mobile application.
                                    </h4>
                                    <h4 style={{
                                        textAlign: "justify",
                                        fontWeight: "400",
                                        fontSize: "1.125rem",
                                        marginTop: "20px"
                                    }}>
                                        The proposed model is depicted through below schematic:
                                    </h4>
                                    <div><img src={riderModel}/></div>
                                    <h4 style={{
                                        textAlign: "justify",
                                        fontWeight: "400",
                                        fontSize: "1.125rem",
                                        marginTop: "20px"
                                    }}>
                                        When the sputum is collected at the collection point, a message will be sent to
                                        surrounding riders through the mobile application to transport the sputum so the
                                        nearest rider can collect and deliver the sputum box. A rider will cover the
                                        distance of 30 to 50 km from all collection points to the delivery points. The
                                        rider will receive an incentive per KM for sputum transportation services. This
                                        incentive will be paid monthly to riders upon the completion of documentation
                                        for verification of services and approvals developed by Mercy Corps and its
                                        partners.
                                    </h4>
                                    <h4 style={{
                                        textAlign: "left",
                                        fontWeight: "400",
                                        fontSize: "1.125rem",
                                        marginTop: "20px"
                                    }}>
                                        Sputum carriers with ice packs will be used for sputum transportation to ensure
                                        that sputum quality is not compromised.
                                    </h4>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="sale-statistic-area" style={{background: "white", padding: "50px 0px"}}>
                        <div class="landing-container" style={{maxWidth: "1070px"}}>
                            <div class="row" style={{marginRight: "0px", marginLeft: "0px"}}>

                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <h1 style={{
                                        textAlign: "center",
                                        fontWeight: "600",
                                        fontSize: "2rem",
                                        fontFamily: "'TiemposText-Semibold',serif",
                                        letterSpacing: "-0.5px"
                                    }}>Download</h1>
                                </div>

                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
                                     style={{textAlign: "center", marginTop: "30px"}}>
                                    <a href={'https://play.google.com/store/apps/details?id=com.riderforhealth.org'} download="RFH Android App">
                                        <img src={apkicon} style={{height: "80px"}}/>
                                        <div style={{fontSize: "16px", paddingTop: "5px", color: "#1176AE "}}>Riders For
                                            Health ( Android App )
                                        </div>
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="bg-container" style={{maxHeight: "725px", overflow: "hidden"}}>

                        <img class="Contactus-bg" src={ContactUs_bg} style={{width: "100%", height: "128vh"}}/>

                        <div class="ContactusContainer">

                            <h1>Contact Us</h1>

                            <div style={{
                                background: "white",
                                position: "relative",
                                height: "100%",
                                padding: "20px",
                                borderRadius: "10px",
                                marginTop: "25px"
                            }}>
                                <form onSubmit={this.SubmitForm} novalidate>

                                    <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <label for=""><span style={{color: "red"}}>* </span>Your Name</label>
                                        <input autocomplete="off" type="text" class="form-control" id="Contact_Name"
                                               required/>
                                    </div>

                                    <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <label for=""><span style={{color: "red"}}>* </span>Contact Number</label>
                                        <input autocomplete="off" pattern="[0][0-9]{10}" type="text"
                                               class="form-control" id="Contact_Number" required/>
                                    </div>

                                    <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <label for=""><span style={{color: "red"}}>* </span>Email</label>
                                        <input autocomplete="off" type="email" class="form-control" id="Contact_Email"
                                               required/>
                                    </div>

                                    <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <label for=""><span style={{color: "red"}}>* </span>Subject</label>
                                        <input autocomplete="off" type="text" class="form-control" id="Contact_Subject"
                                               required/>
                                    </div>

                                    <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <label for=""><span style={{color: "red"}}>* </span>Message</label>
                                        <textarea required class="form-control" id="Contact_Message" rows="4"
                                                  style={{height: "100%"}}></textarea>
                                    </div>

                                    <div style={{marginTop: "15px"}}
                                         class="col-lg-12 col-md-12 col-sm-12 col-xs-12 row">
                                        <button type="submit" class="btn btn_style1"
                                                style={{marginLeft: "15px"}}>Submit
                                        </button>
                                    </div>

                                </form>
                            </div>

                        </div>

                    </div>

                </div>

            </div>
        )
    }

    componentDidMount() {

    }

    SubmitForm = (e) => {
        e.preventDefault()
        this.props.ShowLoader({Isloading: true})
        var Parameters = {
            senderName: $("#Contact_Name").val(),
            senderNumber: $("#Contact_Number").val(),
            senderEmail: $("#Contact_Email").val(),
            subject: $("#Contact_Subject").val(),
            message: $("#Contact_Message").val(),
        }
        Common.Ajax("", "Post", false, Common.APILinks.SendContactMail, JSON.stringify(Parameters), (resp) => {
                this.props.ShowLoader({Isloading: false})
                if (resp.status == true) {
                    this.props.ShowAlert({Type: 1, Msg: "Mail sent successfully"})
                    setTimeout(() => {
                        $("#Alertmsgbtn").click()
                    }, 50);
                    $("#Contact_Name").val("")
                    $("#Contact_Number").val("")
                    $("#Contact_Email").val("")
                    $("#Contact_Subject").val("")
                    $("#Contact_Message").val("")
                } else {
                    this.props.ShowAlert({Type: 0, Msg: resp.message})
                    setTimeout(() => {
                        $("#Alertmsgbtn").click()
                    }, 50);
                }
            },
            (error) => {
                this.props.ShowLoader({Isloading: false})
                this.props.ShowAlert({Type: 0, Msg: "Something went wronge, please try again."})
                setTimeout(() => {
                    $("#Alertmsgbtn").click()
                }, 50);
            }
        )


    }

}

export default connect(mapStateToProps, mapDispatchToProps)(Landing);

